import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { ASSETS } from "@/constants/site";
import { CheckCircle2 } from "lucide-react";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <div className="section-label mb-6">{t.about.label}</div>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight">
            {t.about.title}
          </h2>
          <p className="mt-8 text-neutral-400 text-base md:text-lg leading-relaxed max-w-xl">
            {t.about.body}
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            {[t.about.pill1, t.about.pill2, t.about.pill3].map((p, i) => (
              <div key={i} className="inline-flex items-center gap-2 border border-[#F5B800]/40 px-4 py-2 text-xs uppercase tracking-[0.2em] font-bold text-[#F5B800]">
                <CheckCircle2 size={14} strokeWidth={2.5} />
                {p}
              </div>
            ))}
          </div>
        </motion.div>

        {/* Staggered images */}
        <div className="lg:col-span-6 relative min-h-[560px]">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="absolute top-0 left-0 w-[70%] aspect-[4/5] overflow-hidden border border-white/10"
          >
            <img src={ASSETS.catDeere} alt="CAT bulldozer and John Deere loader" className="w-full h-full object-cover machine-img" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="absolute bottom-0 right-0 w-[62%] aspect-[4/5] overflow-hidden border border-white/10"
          >
            <img src={ASSETS.altecWinter} alt="Altec bucket truck" className="w-full h-full object-cover machine-img" />
          </motion.div>

          {/* Amber tag */}
          <div className="absolute top-[46%] right-4 bg-[#F5B800] text-black px-4 py-2 text-[10px] uppercase tracking-[0.3em] font-black">
            USA · Global
          </div>
        </div>
      </div>
    </section>
  );
}
